import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useBundle } from '@amzn/react-arb-tools';
import { ReportActionSource } from '@amzn/handshake-painter-typescript-client/v1';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Theme, { useTheme } from '@amzn/meridian/theme';
import { RetailRoutes, useRetailRedirectUrls } from 'src/utils/links';
import { colors } from 'src/utils/colors';
import { ExternalLink } from 'src/common/externalLink';
import { getExperimentArm } from 'src/utils/experiments';
/**
 * Footer for the application
 * Converted from: https://code.amazon.com/packages/HandshakePainterComponents/blobs/mainline/--/src/kata/templates/common/Footer.kata
 *
 * TODO:
 *  - Detail page has extra `padding-bottom: 130px`. Why?
 */
export const Footer = ({ experiments }) => {
    const [bundle, isBundleLoading] = useBundle('pages.app');
    const isEuLaunchEnabled = getExperimentArm(experiments, 'WEBLAB_PAINTER_EU_LAUNCH') === 'T1';
    const redirectUrls = useRetailRedirectUrls([
        RetailRoutes.CONDITIONS_OF_USE,
        RetailRoutes.PRIVACY_NOTICE,
        RetailRoutes.COOKIES_NOTICE,
        RetailRoutes.IBA_NOTICE,
    ]);
    const theme = useTheme();
    if (isBundleLoading)
        return null;
    const currentYear = new Date().getFullYear();
    // Prime and non-prime colors are the same for the footer
    const backgroundColor = theme.mode === 'dark' ? colors.headerFooterDarkMode : colors.headerFooterLightMode;
    return (_jsx(Theme, { mode: "dark", children: _jsxs(Column, { alignmentHorizontal: "center", backgroundColor: backgroundColor, spacingInset: "400", spacing: "200", "data-testid": "footer", children: [_jsxs(Row, { alignmentHorizontal: "center", "data-testid": "footer-links", children: [_jsx(ExternalLink, { id: "conditions-of-use-link", href: redirectUrls.CONDITIONS_OF_USE, source: ReportActionSource.Footer, children: _jsx(Text, { type: "b100", children: bundle.getMessage('conditionsOfUse') }) }), _jsx(ExternalLink, { id: "privacy-notice-link", href: redirectUrls.PRIVACY_NOTICE, source: ReportActionSource.Footer, children: _jsx(Text, { type: "b100", children: bundle.getMessage('privacyNotice') }) })] }), isEuLaunchEnabled && (_jsxs(Row, { "data-testid": "footer-privacy-pref-links", children: [_jsx(ExternalLink, { href: redirectUrls.COOKIES_NOTICE, id: "cookies-notice-link", source: ReportActionSource.Footer, children: _jsx(Text, { type: "b100", children: bundle.getMessage('cookiesNotice') }) }), _jsx(ExternalLink, { href: redirectUrls.IBA_NOTICE, id: "iba-notice-link", source: ReportActionSource.Footer, children: _jsx(Text, { type: "b100", children: bundle.getMessage('ibaNotice') }) })] })), _jsx(Row, { "data-testid": "copyright", children: _jsx(Text, { type: "b100", children: bundle.formatMessage('copyRight', { currentYear }) }) })] }) }));
};
